import { render, staticRenderFns } from "./task.vue?vue&type=template&id=6de2a15e&scoped=true"
import script from "./task.vue?vue&type=script&lang=ts"
export * from "./task.vue?vue&type=script&lang=ts"
import style0 from "./task.vue?vue&type=style&index=0&id=6de2a15e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de2a15e",
  null
  
)

export default component.exports